export const doneOrderActionTypes = {
  setFilters: '[DoneOrders] Set filters',
};
